<template>
    <b-modal
        id="modal-details-forum"
        ref="modal-details-forum"
        centered
        ok-only
        ok-title="Cerrar"
        ok-variant="secondary"
        size="xl"
        :title="modalTitle"
        @show="loadForumPostComments()"
        @hidden="resetSelectedForumPost()"
    >
        <!-- Original Post card -->
        <b-card v-if="selectedForumPostObject" class="mb-2">
            <b-card-text>
                <!-- The contents of this div will render the (pre-sanitized) forumPost description html -->
                <div v-html="selectedForumPostObject.body" />
            </b-card-text>

            <template v-slot:footer>
                <div class="text-right">
                    {{ selectedForumPostObject.authorName }} - {{ selectedForumPostObject.latestUpdateDate }}
                </div>
            </template>
        </b-card>

        <!-- Comments cards -->
        <div v-if="getActiveForumPostComments">
            <b-card
                v-for="comment in getActiveForumPostComments"
                :key="`forumComment-${comment.id}`"
                class="mb-2"
            >
                <b-card-text>
                    <!-- The contents of this div will render the (pre-sanitized) forumPost description html -->
                    <div v-html="comment.body" />
                </b-card-text>

                <template v-slot:footer>
                    <div class="float-right">
                        {{ comment.authorName }} - {{ comment.latestUpdateDate }}
                    </div>
                    <b-button
                        v-if="isUserStudenTeacherOrBetter || comment.authorId === userData.id"
                        variant="danger"
                        size="sm"
                        class="ml-2"
                        @click="onDelete(comment)"
                    >
                        <b-icon-trash-fill />
                    </b-button>
                </template>
            </b-card>
        </div>
        <b-card v-else bg-variant="light">
            <b-card-text>
                No existe ninguna respuesta para este tema.
                </b-card-text>
        </b-card>

        <CommentCreateModal @reloadForumPostCommentsData="loadForumPostComments()" />

    </b-modal>
</template>

<script>
import CommentCreateModal from './CommentCreateModal'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'ForumPostDetailsModal',
    components: {
        CommentCreateModal
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedForumPostObject',
            'userData',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'getActiveForumPostComments',
            'isUserStudenTeacherOrBetter'
        ]),
        modalTitle () {
            if (this.selectedForumPostObject) {
                return this.selectedForumPostObject.title
            }
            return ''
        }
    },
    methods: {
        ...mapActions([
            'readForumPostComments',
            'deleteForumPostComment'
        ]),
        resetSelectedForumPost () {
            this.$store.commit('RESET_SELECTED_FORUM_POST_OBJECT')
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        },
        async loadForumPostComments () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, forumPostId: this.selectedForumPostObject.id }
                await this.readForumPostComments(payloadData)
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            } finally {
                loader.hide()
            }
        },
        async onDelete (comment) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', comment)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el comentario del tema.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDelete()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDelete () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = {
                    courseSiteId: this.activeSite.id,
                    forumPostId: this.selectedForumPostObject.id,
                    commentId: this.selectedCrudObject.id
                }
                await this.deleteForumPostComment(payloadData)
                this.$store.commit('DELETE_FORUM_POST_COMMENT_OBJECT', this.selectedCrudObject.id)
                this.$root.infoToast('El comentario ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el comentario, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    }
}
</script>
